/**
 * Algolia logo and "Powered by" badge for search results.
 * Brand: https://algolia.frontify.com/d/1AZwVNcFZiu7/style-guide (Algolia blue #5468FF)
 */

import React from 'react';
import './AlgoliaLogo.css';

/** Algolia primary blue per brand guidelines */
export const ALGOLIA_BLUE = '#5468FF';

/**
 * Algolia logo mark (blue circle with white "a" style).
 * Brand color #5468FF per Algolia Style Guide.
 */
function AlgoliaLogoSvg({ width = 20, height = 20, className = '' }) {
  return (
    <svg
      className={`algolia-logo-svg ${className}`}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <circle cx="12" cy="12" r="11" fill={ALGOLIA_BLUE} />
      <path
        fill="white"
        d="M12 6.5a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9zm0 7a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
      />
      <circle cx="12" cy="12" r="2" fill="white" />
    </svg>
  );
}

/**
 * "Powered by Algolia" badge to show beside search results.
 * Compact: logo + text; optional link to algolia.com.
 */
export default function AlgoliaLogo({ compact = true, showText = true, className = '' }) {
  return (
    <span className={`algolia-powered ${className}`} title="Search powered by Algolia">
      <AlgoliaLogoSvg width={16} height={16} />
      {showText && (
        <span className="algolia-powered-text">
          {compact ? 'Algolia' : 'Powered by Algolia'}
        </span>
      )}
    </span>
  );
}
